import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Utils } from '@app/_core/helper/Utils';

import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
@Injectable({
    providedIn: 'root',
})
export class CampaignService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private webStorageService: WebStorageService,
        private loaderService: LoaderService
    ) { }

    setUserDetails() {
        const pl: any = {};
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.capResults = true;
        pl.company = company;
        return pl;
    }

    GetCampaigns(): any {
        let pl: any = {};
        pl = this.setUserDetails();
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetCampaigns`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getCampaignById(id: number): any {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.id = id;
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetCampaignByID`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    createCampaign(campaignDetails) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.CampaignModel = campaignDetails;
        pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');
        pl.company = this.webStorageService.getItemFromSessionStorage('company');
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/CreateCampaign`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getFilesByID(fileIDs: any[]) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.fileIDs = fileIDs;
        pl.areDisabled = false;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/privatefiles/GetFilesByID`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getFileTypesByExtension(extensions: any[]) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.extensions = extensions;
        pl.distinct = false;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/privatefiles/GetFileTypesByExtension`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    saveFile(blob: any, isPublic: any) {
        const formData = new FormData();
        const company = this.webStorageService.getItemFromSessionStorage('company');
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const fileName = 'Onvida_' + company + '_' + new Date().toISOString().split('T')[0] + '_' + Date.now() + '.wav';
        const file = new File([blob], fileName);
        const fixFileName: any = false;
        formData.append('file', file);
        formData.append('isPublic', isPublic);
        formData.append('fileID', '');
        formData.append('company', company);
        formData.append('user', JSON.stringify(user));
        formData.append('fixFileName', fixFileName);
        formData.append('description', '');
        //console.log('formData', formData);
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/privatefiles/SaveFile`, formData).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    uploadFile(file: any, fileExt: string, isPublic: any, fileID: string) {
        const formData = new FormData();
        const company = this.webStorageService.getItemFromSessionStorage('company');
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        let description = '';

        //let fileName = "Onvida_"+ company + "_" +  new Date().toISOString().split('T')[0] + "_" + Date.now() + "." + fileExt;
        const fileName = file.name.replace(/\s/g, "");
        if (fileID) {
            description = 'ContactDataFile';
        }

        const fixFileName: any = false;
        formData.append('file', file, fileName);
        formData.append('isPublic', isPublic);
        formData.append('fileID', fileID);
        formData.append('company', company);
        formData.append('user', JSON.stringify(user));
        formData.append('fixFileName', fixFileName);
        formData.append('description', description);
       // console.log('formData', formData);
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/privatefiles/SaveFile`, formData).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getIVRPromptAPIMethods() {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.scan = false;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/manager/GetIVRPromptAPIMethods`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getPhoneNumbers() {
        let pl: any = {};
        pl = this.setUserDetails();

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetPhoneNumbers`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getCampaignTypes() {
        let pl: any = {};
        pl = this.setUserDetails();
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetCampaignTypes`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getResponseQueues() {
        let pl: any = {};
        pl = this.setUserDetails();
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetResponseQueues`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    checkClientAllowsMachineDetection() {
        let pl: any = {};
        pl = this.setUserDetails();
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/CheckClientAllowsMachineDetection`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                return res?.Response?.Data;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getChannelTypes() {
        let pl: any = {};
        pl = this.setUserDetails();

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetChannelTypes`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getIVRPromptsByResponseQueue(activityID) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.activityID = activityID;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetIVRPromptsByResponseQueue`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getCampaignLoadStatus(campaignID, eventId=null) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.campaignID = campaignID;
        pl.eventID = eventId;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetCampaignLoadStatus`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    getCampaignDetailsByID(campaignID) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.campaignID = campaignID;
        pl.sortColumn = 'User ID';
        pl.filterDict = [];
        pl.searchValue = null;
        pl.searchField = null;
        pl.sortColumn = 'User ID';
        pl.sortDescend = false;
        pl.rowCount = 108;
        pl.rowOffset = 0;
        pl.filterOptionRequestColumn = null;
        pl.isExport = false;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetCampaignDetailsByID`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    S3FileExists(filename) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.filename = filename;
        pl.bucketName = environment.templateS3Bucket;
        delete pl.capResults;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/S3FileExists`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    processDataFile(campaignID, fileID) {
        let pl: any = {};
        pl = this.setUserDetails();
        pl.campaignID = campaignID;
        pl.fileID = fileID;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/ProcessDataFile`, pl).pipe(
            map(res => {
                this.loaderService.display(false);

                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    StartTestPhoneCall(MakeTestData: any) {
        let company = this.webStorageService.getItemFromSessionStorage('company');
        let user = this.webStorageService.getItemFromSessionStorage('currentUser');
        let formData = MakeTestData.formData;
        let messageDescription = formData.messageSource;
        let messageSource = '';
        if (formData.messageSource === 'texttospeech') {
            messageSource = formData.ttsMessage;
        } else if (formData.messageSource === 'customapi') {
            messageSource = 'custom';
        } else if (formData.messageSource === 'customivrmessage') {
            messageSource = 'custom';
            //  if(formData.messageSource ==='texttospeech'){
            //   messageSource = formData.ttsMessage;
            // }
        } else if (formData.messageSource === 'uploadfile') {
            messageSource = formData.messageDescription;
        } else if (formData.messageSource === 'recording') {
            messageSource = formData.messageDescription;
        } else {
            messageSource = formData.messageSource;
        }

        const uc = {
            campaignID: MakeTestData.selectedCampaignId, //type int
            callFrom: formData.callFrom, //type string
            callTo: MakeTestData.phoneNumber, //type string
            callToType: (MakeTestData.CallType == null ? 'HardPhone' : MakeTestData.CallType), //type string
            messageSource: messageSource, //type string
            messageDescription: messageDescription, //type string
            playMessage: formData.playMessage, //type string 
            actionKey: formData.actionKey, //type string 
            responseSkill: formData.responseSkill, //type int? 
            responseQueue: formData.responseQueue, //type int? 
            responseQueueIVRPrompt: formData.responseQueueIVRPrompts, //type int? 
            MachineDetection: formData.MachineDetection,
            company: company, // type string
            user: user
        };
       // console.log("payload", uc)
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/MakeTestCall`, uc).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    IsTestCallInProgress(callID) {
        let company = this.webStorageService.getItemFromSessionStorage('company');
        let user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const uc = {
            callID: callID,
            company: company, // type string
            user: user
        };
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/IsTestCallInProgress`, uc).pipe(
            map(res => {
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    cancelTestCall(callID){
        let company = this.webStorageService.getItemFromSessionStorage('company');
        let user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const uc = {
            callID: callID,
            company: company, // type string
            user: user
        };
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/CancelTestCall`, uc).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    SendTestText(TestSMSData: any) {
        let company = this.webStorageService.getItemFromSessionStorage('company');
        let user = this.webStorageService.getItemFromSessionStorage('currentUser');
        let payload={
            company:company,
            user:user
        }
        payload={...payload,...TestSMSData}
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/SendTestText`, payload).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    SendTestCustomText(TestSMSData: any) {
        let company = this.webStorageService.getItemFromSessionStorage('company');
        let user = this.webStorageService.getItemFromSessionStorage('currentUser');
        let payload={
            company:company,
            user:user
        }
        payload={...payload,...TestSMSData}
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/SendTestCustomText`, payload).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    getCampaignDetailsExcel(item: any) {
        let pl: any = {};
        pl = item;
        pl.company = this.webStorageService.getItemFromSessionStorage('company');
        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/campaign/GetCampaignDetailsExcel`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
}
